import axios from 'axios'

export default {
  //テスト用のAPIへポスト送信
  login(data) {
    return axios({
      method: 'POST',
      url: '/login',
      data: data,
    })
  },
  auth(data) {
    return axios({
      method: 'POST',
      url: '/api/auth',
      data: data.user,
      headers: { 'Authorization': `Bearer ${data.token}` },
    })
  },
  newsItems(data) {
    return axios({
      method: 'GET',
      url: '/api/news/items',
      params: data,
      headers: { 'Authorization': `Bearer ${data.token}` },
    })
  },
  createNews(data) {
    return axios({
      method: 'POST',
      url: '/api/news/create',
      data: data,
      headers: { 'Authorization': `Bearer ${data.token}` },
    })
  },
  editNews(data) {
    return axios({
      method: 'POST',
      url: '/api/news/edit',
      data: data,
      headers: { 'Authorization': `Bearer ${data.token}` },
    })
  },
  getNewsDetails(data) {
    return axios({
      method: 'GET',
      url: '/api/news/details',
      params: data,
      headers: { 'Authorization': `Bearer ${data.token}` },
    })
  },
  getArticleUser(data) {
    return axios({
      method: 'GET',
      url: '/api/articleUser',
      params: data,
      headers: { 'Authorization': `Bearer ${data.token}` },
    })
  },
  getAllNews(data) {
    return axios({
      method: 'GET',
      url: '/api/news',
      params: data,
      headers: { 'Authorization': `Bearer ${data.token}` },
    })
  },
  deleteNews(data) {
    return axios({
      method: 'POST',
      url: '/api/news/delete',
      data: data,
      headers: { 'Authorization': `Bearer ${data.token}` },
    })
  },
  readDetials(data) {
    return axios({
      method: 'POST',
      url: '/api/news/read',
      data: data,
      headers: { 'Authorization': `Bearer ${data.token}` },
    })
  },
  createGroup(data) {
    return axios({
      method: 'POST',
      url: '/api/group/create',
      data: data,
      headers: { 'Authorization': `Bearer ${data.token}` },
    })
  },
  deleteGroup(data) {
    return axios({
      method: 'POST',
      url: '/api/group/delete',
      data: data,
      headers: { 'Authorization': `Bearer ${data.token}` },
    })
  },
  editGroup(data) {
    return axios({
      method: 'POST',
      url: '/api/group/edit',
      data: data,
      headers: { 'Authorization': `Bearer ${data.token}` },
    })
  },
  createCategory(data) {
    return axios({
      method: 'POST',
      url: '/api/category/create',
      data: data,
      headers: { 'Authorization': `Bearer ${data.token}` },
    })
  },
  editCategory(data) {
    return axios({
      method: 'POST',
      url: '/api/category/edit',
      data: data,
      headers: { 'Authorization': `Bearer ${data.token}` },
    })
  },
  users(data) {
    return axios({
      method: 'GET',
      url: '/api/users',
      params: data,
      headers: { 'Authorization': `Bearer ${data.token}` },
    })
  },
  singup(data) {
    return axios({
      method: 'POST',
      url: '/api/signup',
      data: data,
      headers: { 'Authorization': `Bearer ${data.token}` },
    })
  },
  editUser(data) {
    return axios({
      method: 'POST',
      url: '/api/user/edit',
      data: data,
      headers: { 'Authorization': `Bearer ${data.token}` },
    })
  },
  deleteUser(data) {
    return axios({
      method: 'POST',
      url: '/api/user/delete',
      data: data,
      headers: { 'Authorization': `Bearer ${data.token}` },
    })
  },
  userNewsList(data) {
    return axios({
      method: 'GET',
      url: '/api/users/news',
      params: data,
      headers: { 'Authorization': `Bearer ${data.token}` },
    })
  },
}
